const API_BASE =
  process.env.REACT_APP_API_URL ||
  "http://localhost:3001";

async function apiFetch(path) {
  const res = await fetch(`${API_BASE}${path}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);
  return data;
}

export async function listTutors(params = {}) {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue;
    qs.set(k, String(v));
  }
  const q = qs.toString();
  const data = await apiFetch(`/api/tutors${q ? `?${q}` : ""}`);
  return data.items || [];
}

export async function getTutorById(id) {
  return apiFetch(`/api/tutors/${encodeURIComponent(id)}`);
}
